import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common'; 
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'; 
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-contact-details-form',
  templateUrl: './contact-details-form.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class ContactDetailsFormComponent {
  @Input() contactDetailsForm!: FormGroup;

  
  static createContactDetailsGroup(): FormGroup {
    return new FormGroup({
      phone: new FormControl("", [Validators.required]),
      mobile: new FormControl(""),
      email: new FormControl("", [Validators.required, Validators.email]),
    });
  }
}

export interface ContactDetails {
  phone: string;
  mobile: string;
  email: string;
}


export const ContactDetailsDefaultValue = {
    phone: "",
    mobile : "",
    email: "",
}